import { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Switch, Tabs } from "antd";

import Fetch from "components/Fetch";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import DeleteButton from "components/buttons/DeleteButton";
import Loading from "components/App/Loading";
import FinishButton from "components/Modals/AdminManageOrder/FinishButton";
// import Filters from "components/dashboard/Filters";
import { getUserState } from "state/selector";
import { states } from "constants/app";
import { GlassCard } from "components/App/styled";
import Table from "./Table";

const Filters = ({ setStatus, reload }) => (
  <div style={{ marginTop: 32 }}>
    نمایش همه :
    <Switch
      style={{ marginRight: 8 }}
      onChange={(state) => {
        reload(true);
        setStatus(state ? "" : "/active");
      }}
    />
  </div>
);

function Index(props) {
  const [reload, setReload] = useState(false);
  const [comments, setComments] = useState(false);
  const [status, setStatus] = useState("/active");

  useEffect(() => {
    Fetch.get(`/comments`, (res) => {
      if (res) {
        console.log("dashboard/comments data", res);
        setComments(res);
        setReload(false);
      }
    });
  }, [reload, status]);

  if (!comments) {
    return <Loading />;
  }
  return (
    <Container>
      <TableContainer>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="بررسی نشده" key="1">
            <Table
              data={comments?.pending}
              reload={reload}
              setReload={setReload}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="تایید شده" key="2">
            <Table
              data={comments?.approved}
              reload={reload}
              setReload={setReload}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="رد شده" key="3">
            <Table
              data={comments?.rejected}
              reload={reload}
              setReload={setReload}
            />
          </Tabs.TabPane>
        </Tabs>
      </TableContainer>
    </Container>
  );
}
const mapStateToProps = (state) => {
  const user = getUserState(state);
  return { user };
};
export default connect(mapStateToProps)(Index);
const Container = styled.div`
  color: ${colors.dark};
`;
const TableContainer = styled.div``;
